import React, { useState } from 'react';
import {
    styled,
    Box,
    List,
    ListSubheader,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse, // wrap
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { groupVisibleChildrenByHeader } from '../utils/navPermissions';
import renderIcon from '../../shared/icons';
import NavItemRenderer from './NavItemRenderer';
import NavChip from './NavChip';

const VerticalLine = styled('div')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '1px',
    backgroundColor: theme.palette.nav.divider.dark,
    borderRadius: 1,
    zIndex: 1,
}));

const CollapseWrap = styled('div')(({ theme }) => ({
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.nav.background.light,
    position: 'relative',
}));

const SubHeader = styled(ListSubheader)(({ theme }) => ({
    backgroundColor: 'transparent',
    color: theme.palette.nav.text.dark,
    pl: 0,
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '11px',
}));

const NavGroupRenderer = ({ item, user, bookmarks }) => {
    const [open, setOpen] = useState(false);

    const visibleGroups = groupVisibleChildrenByHeader(item.children, user);
    if (visibleGroups.length === 0) return null;

    return (
        <Box>
            <ListItemButton
                sx={{
                    px: 2,
                    '&:hover': {
                        backgroundColor: (theme) => theme.palette.nav.background.highlight,
                    },
                }}
                onClick={() => setOpen((prev) => !prev)}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: 1,
                    }}
                >
                    {renderIcon(item.icon)}
                </ListItemIcon>
                <ListItemText
                    primary={
                        <div
                            style={{
                                fontSize: '14px',
                                fontWeight: 500,
                            }}
                        >
                            {item.title}
                        </div>
                    }
                />
                {item.badge && <NavChip chip={item.badge} />}
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <CollapseWrap>
                    <List disablePadding>
                        {visibleGroups.map((group, idx) => (
                            <div key={group.header}>
                                {group.header && (
                                    <SubHeader
                                        disableSticky
                                        sx={{ mt: idx > 0 ? 2 : 0 }} // wrap
                                    >
                                        {group.header}
                                    </SubHeader>
                                )}
                                {group.items.map((groupItem) => (
                                    <div
                                        key={groupItem.id}
                                        style={{
                                            display: 'flex',
                                            position: 'relative',
                                        }}
                                    >
                                        <VerticalLine />
                                        <div style={{ width: '100%' }}>
                                            <NavItemRenderer
                                                noIcon
                                                item={groupItem}
                                                user={user}
                                                bookmarks={bookmarks}
                                                color={groupItem.color}
                                                textSx={{
                                                    fontSize: '13px',
                                                    fontWeight: 400,
                                                    ...groupItem.textSx,
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </List>
                </CollapseWrap>
            </Collapse>
        </Box>
    );
};

export default NavGroupRenderer;
